<template> 
    <v-dialog v-model="show" max-width="350" overlay-color="#000" overlay-opacity="0.9">
        <v-card class="px-2 pb-1">
            <v-card-title class="headline">تسجيل الخروج</v-card-title>
            <v-card-text class="grey--text mt-3">هل أنت متأكد من أنك تريد تسجيل الخروج؟</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="show = false">إلغاء</v-btn>
                <v-btn color="red darken-1" :loading="loading" text @click="show = false; logout()">تسجيل الخروج</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['value'],
    data(){
        return {
            show: false,
            loading: false,
        }
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {

        logout(){
            // remove any intervals or realtime connections
            this.loading = true;
            this.$store.dispatch('fastPostAction', {url: '/logout'}).then(()=>{
                this.loading = false;
                this.$store.dispatch('logout');
                this.$router.push({name: 'login'});
                window.setTimeout(()=>{
                    // reload to reset vuex store
                    window.location.reload(true);
                }, 250);
            });
        },
    }
}
</script>

<style>

</style>